<template>
    <div id="preview">
        <headers :title="titles|dateFormat('YYYY-MM-DD')"
                 v-if="type==0"></headers>
        <headers :title="titles"
                 v-else></headers>
        <div v-if="loading">
            <div class="itemLength">共{{totalNum}}题</div>
            <div class="questions">
                <div class="question"
                     v-for="(item,qindex) in questions">
                    <div class="quest_title"
                         v-if="item.subject.content||item.subject.image">
                        <p v-if="item.subject.content!=''"
                           v-html="item.subject.content"></p>
                        <img :src="item.subject.image"
                             v-if="item.subject.image!=''">
                    </div>
                    <div v-for="ask in item.asks">
                        <!-- 选择题 -->
                        <div class="choose"
                             v-if="ask.display_type==1">
                            <choice :question='ask'
                                    :askLength='item.asks.length'></choice>
                        </div>
                        <!-- 连线题 -->
                        <div class="line"
                             v-if="ask.display_type==4">
                            <line-component :ask='ask'
                                            :sheet="ask.right_answer"
                                            :onlyshow='true'
                                            :askLength='item.asks.length'></line-component>
                        </div>
                        <!-- 填空 -->
                        <div v-if='ask.display_type == 2'>
                            <blanks :question='ask'
                                    :askLength='item.asks.length'></blanks>
                        </div>
                    </div>
                    <div class="ask_bottom clearfix">
                        <span class="wrong_rate">错误率：{{item.ratio}}%</span>
                        <i class="icon-fangxingkuang"
                           v-if="type!=0 && !item.choose"
                           @click="join(item,qindex)">加入</i>
                        <i class="icon-fangxing"
                           v-if="type!=0 && item.choose"
                           @click="dele(item,qindex)">移除</i>
                    </div>
                </div>
            </div>
            <div class="bottom_btn clearfix"
                 v-if="type==1">
                <div class="left_btn"><i></i><span>已选（{{totalNum}}题）</span></div>
                <div v-if='totalNum>0'
                     :class="['right_btn',{'able':totalNum>0}]"
                     @click='submit'>去发布</div>
                <div v-else
                     :class="['right_btn',{'disable':totalNum==0}]">去发布</div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import line from 'VIEWS/math/module/line.vue';
import choice from 'VIEWS/math/module/choice.vue'  //选择题
import blanks from 'VIEWS/math/module/blanks.vue'  //填空题
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            titles: this.$route.query.name || '习题预览',
            type: this.$route.params.type,//0单个预览，1全部预览
            questions: [],
            loading: false,
            totalNum: 0,
            sid: this.$route.params.sid
        }
    },
    async created () {
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        let _qids = []
        this.qids.forEach(q => {
            _qids.push(q.qid);
        });
        _qids = _qids.join(',')
        //await 方法不能删除，否则会有公式不解析问题 时差造成  --zd 2018.11.08
        await this.$http.post(API_URL_TASK_API + '/maths/questions', { qid: _qids, sid: this.sid }).then(res => {
            this.loading = true;
            if (res.data.response === 'ok') {
                this.questions = res.data.data;
                this.questions.forEach((m, n) => {
                    m.choose = true;
                    this.qids.forEach(q => {
                        if (q.qid == m.id) {
                            m.ratio = q.ratio
                        }
                    });
                    m.asks.forEach(m => {
                        this.totalNum += 1
                    });
                });
            }
        });
        this.$nextTick(function () {
            MathJax.Hub.Typeset(document.body)
        })
    },
    computed: {
        qids () {
            return this.$store.state.math.wrong
        },
    },
    components: {
        headers,
        'line-component': line,
        loadingS,
        blanks,
        choice
    },
    methods: {
        dele (qid, index) {
            let len = qid.asks.length;
            this.totalNum -= len;
            qid.choose = !qid.choose;
            this.questions.splice(index, 1, qid);
        },
        join (qid, index) {
            // if (this.totalNum > 30) {
            //   layer.tips('已经超出30道题,不能再添加试题了');
            //   return false
            // }
            if (this.sid == 21) {
                if (this.totalNum > 100) {
                    layer.tips('已经超出100道题，不能再添加试题了');
                    return false
                }
            } else if (this.sid == 22) {
                if (this.totalNum > 50) {
                    layer.tips('已经超出50道题，不能再添加试题了');
                    return false
                }
            }
            let len = qid.asks.length;
            this.totalNum += len;
            qid.choose = !qid.choose;
            this.questions.splice(index, 1, qid);
        },
        submit () {
            // if (this.totalNum > 30) {
            //   layer.tips(' 已超出30道题,无法发布');
            //   return false
            // }
            if (this.totalNum > 100) {
                layer.tips('已经超出100道题，无法发布');
                return
            }
            if (this.sid == 21) {
                if (this.totalNum > 100) {
                    layer.tips('已经超出100道题，无法发布');
                    return false
                }
            } else if (this.sid == 22) {
                if (this.totalNum > 50) {
                    layer.tips('已经超出50道题，无法发布');
                    return false
                }
            }
            let that = this;
            let details = [];
            this.questions.forEach((m, n) => {
                if (m.choose) {
                    let obj = {};
                    obj.qid = m.id;
                    details.push(obj)
                }
            });
            this.$store.commit('setWrong', details);
            this.$router.push('/sx/release/' + this.sid + '/' + 4)
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#preview {
    padding-bottom: 100px / $ppr;
}

.question {
    margin-bottom: 25px / $ppr;
}

.itemLength {
    font-size: 30px / $ppr;
    font-weight: bold;
    color: #333;
    height: 96px / $ppr;
    padding-left: 24px / $ppr;
    line-height: 96px / $ppr;
    background: #fff;
    margin-bottom: 24px / $ppr;
}

.quest_title {
    padding: 25px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
}

.ask_bottom {
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    background: #fff;
    padding: 0 25px / $ppr;
    position: relative;
    .wrong_rate {
        color: #999;
        font-size: 24px / $ppr;
        float: left;
    }
    i {
        display: inline-block;
        position: absolute;
        &.icon-fangxingkuang {
            top: 0.5rem;
            text-align: center;
            line-height: 48px / $ppr;
            width: 122px / $ppr;
            right: 0.8rem;
            border: 1px / $ppr solid #5e89ef;
            color: #5e89ef;
            border-radius: 1.25rem;
            font-size: 28px / $ppr;
        }
        &.icon-fangxing {
            top: 0.5rem;
            text-align: center;
            line-height: 48px / $ppr;
            width: 122px / $ppr;
            right: 0.8rem;
            border: 1px / $ppr solid #ff6600;
            color: #ff6600;
            border-radius: 1.25rem;
            font-size: 28px / $ppr;
        }
    }
}

.line {
    background: #fff;
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    font-size: 30px / $ppr;
    text-align: center;
    .left_btn {
        width: 70%;
        float: left;
        background: #f0f0f0;
        color: #333;
        position: relative;
        i {
            position: absolute;
            z-index: 1;
            top: 25px / $ppr;
            display: inline-block;
            width: 50px / $ppr;
            height: 42px / $ppr;
            background: url("./img/icon1.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
        span {
            display: inline-block;
            padding-left: 60px / $ppr;
        }
    }
    .right_btn {
        width: 30%;
        float: right;
    }
    .able {
        color: #fff;
        background: #5e89ef;
    }
    .disable {
        color: #999;
        background: #ccc;
    }
}

.question /deep/ .title_t > img {
    left: 0;
}
</style>
